import { isNumber } from 'lodash';
import { EmptyText } from 'src/utils/constants/config';

export const getNumberOrDefault = (n: ExpectedAny, defaultValue = 0) => {
  if (isNumber(n)) return n;
  return defaultValue ?? 0;
};

export const formatNumberWithChar = (num: number) => {
  if (!num) return EmptyText;

  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1)}M`;
  } else if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}K`;
  } else {
    return num.toString();
  }
};

export const calculatePercent = (n?: number, total?: number) => {
  if (!n || !total) return 0;
  return Number(((n * 100) / total).toFixed(2));
};

export const formatNumberWithSuffix = (num: number): string => {
  if (!num) return '0';
  if (num <= 1000) return num.toLocaleString();
  const stringNum = num.toString();
  const roundedNum = Math.floor(num / Math.pow(10, stringNum.length - 1)) * Math.pow(10, stringNum.length - 1);
  return `${roundedNum.toLocaleString()}+`;
};
